import { MenuItem, TableCell, TableRow } from '@material-ui/core'
import React from 'react'

// utils
import { hasAccess } from '../../utils/api'
import { onChangeEditHOF } from '../../utils/common'
import { EditableSelect, EditableSwitch, EditableTextField } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'

export default class TaxDisplayNameItem extends React.Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => {
      if (this.props.clearEditingIndex) this.props.clearEditingIndex()
      if (this.props.disableEdit) this.props.disableEdit()
      this.props.handleAnyEdit(false)
    })
  }

  onCancel = () => {
    if (this.props.clearEditingIndex) this.props.clearEditingIndex()
    if (this.props.onCancel) this.props.onCancel()
    this.props.handleAnyEdit(false)
  }

  onEdit = () => {
    if (this.props.setEditingIndex) this.props.setEditingIndex()
    if (this.props.enableEdit) this.props.enableEdit()
    this.props.handleAnyEdit(true)
  }

  render() {
    const {
      data = {},
      isEditing = false,
      companyFeatures = {},
      taxTypeMapping = false,
      taxTypeOptions = [],
    } = this.props
    const selectedTaxType = taxTypeOptions?.find((opt) => opt.value === data.taxType)?.label

    return (
      <TableRow>
        <TableCell>{data.taxTerritory || ''}</TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.name || ''}
            editMode={isEditing}
            value={data.name}
            onChange={this.onChange('name')}
            type="text"
          />
        </TableCell>
        {companyFeatures.enableAppendTax ? (
          <TableCell className="cell-wrap-word">
            <EditableSwitch
              valueToRender={data.appendTax ? 'Enabled' : 'Disabled'}
              checked={data.appendTax}
              editMode={isEditing}
              onChange={this.onChange('appendTax', true)}
            />
          </TableCell>
        ) : null}
        {taxTypeMapping && (
          <TableCell className="cell-wrap-word">
            <EditableSelect
              value={data.taxType ?? 'none'}
              onChange={this.onChange('taxType')}
              valueToRender={selectedTaxType ?? 'None'}
              editMode={isEditing}
            >
              <MenuItem value="none">None</MenuItem>
              {taxTypeOptions.map(({ value, label }) => (
                <MenuItem value={value} key={value}>
                  {label}
                </MenuItem>
              ))}
            </EditableSelect>
          </TableCell>
        )}
        <TableCell className="cell-wrap-word">
          {hasAccess() && (!this.props.isAnyEditing || isEditing) ? (
            <div>
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.onEdit}
                editMode={isEditing}
                disabled={!isEditing && this.props.isAnyEditing}
              />
            </div>
          ) : null}
        </TableCell>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TaxOption/TaxDisplayNameItem.js